<div class="se-modal-resign-container mat-mdc-dialog-container">
    <div class="se-dialog-header se-flex mat-elevation-z6">
        <p class="header-text" translate>ReSign</p>
    </div>
    <ag-grid-angular
        style="height: 80%; padding: 10px"
        [rowData]="gridData"
        [columnDefs]="columnsDef"
        [rowSelection]="rowSelection"
        (selectionChanged)="onSelectionChanged($event)"
        (gridReady)="onGridReady($event)"
        [modules]="agGridModuls"
        [theme]="agGridTheme"
    />
    <div style="display: flex; justify-content: flex-end; padding: 24px">
        <button class="se-modal-resign-button" mat-button color="primary" (click)="close()">
            <p style="margin: 0" translate>Cancel</p>
        </button>
        <button
            class="se-modal-resign-button"
            mat-button
            color="primary"
            [disabled]="isDisabled"
            (click)="sendReportsForCDA()"
        >
            {{ "SendToCda" | translate }}
        </button>
    </div>
</div>
